<template>
  <div>
    <!--在视频外面加一个容器-->
    <div class="video-container" ref="videoContainer">
      <div class="input_video">
        <video id="videoRef" class="video-js video-class"></video>
      </div>
    </div>
    <div class="tab-container" ref="tabContainer">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        class="tab-item"
        :class="{ 'tab-active': currentActive === index }"
        @click="handleClickTabItem(index)"
      >
        {{ item }}
      </div>
      <div class="tab-solid" :style="tabStyle"></div>
    </div>
    <div class="interact-container" :style="interactStyle">
      <!-- 互动 -->
      <div class="interact" v-if="currentActive === 0">
        <div class="interact-item" v-for="item in interactList" :key="item.id">
          <!-- 用户评价 -->
          <div class="user" v-if="item.sendType === '1'">
            <img class="interact-item-img" :src="item.publicImg" alt="" />
            <div class="interact-item-desc">
              <span class="interact-item-desc-nickname">{{ item.nickname }}</span>
              <span>
                {{ item.sendContent }}
              </span>
            </div>
          </div>
          <!-- 游客进入 -->
          <div class="tourist" v-if="item.sendType === '2'">
            {{ item.nickname }}
          </div>
        </div>
      </div>
      <div v-else class="introduce">
        <!-- {{ livingRoomDetail.notice }} -->
        <div class="introduce-title">
          <div class="title-desc">{{ livingRoomDetail.name }}</div>
          <div class="play-count">
            <img src="~@/assets/image/video-play.png" alt="" />
            <div class="play-count-desc">2.9万</div>
          </div>
        </div>

        <div class="anchor">
          <div class="record-button">主持人</div>
          <div class="anchor-bottom">
            <div class="anchor-desc">
              <img :src="livingRoomDetail.hostImage" alt="" />
              <div class="anchor-nickname">{{ livingRoomDetail.nickname }}</div>
            </div>
            <div class="focus-button" @click="handleClickFocus">关注</div>
          </div>
        </div>

        <!-- 往期回顾 -->
        <div class="record">
          <div class="record-button">往期回顾</div>
          <van-empty description="暂无回顾" />
          <!-- <div class="record-item" v-for="(item, index) in recordList" :key="index">
            <div class="item-left">
              <img src="~@/assets/image/qricon.png" alt="" />
              <div class="item-duration">04:34</div>
            </div>
            <div class="item-right">
              <div class="item-right-top text-line-2">
                哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈
              </div>
              <div class="item-right-bottom">
                <img src="~@/assets/image/video-play.png" alt="" />
                <div class="item-right-count">2.9万</div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <van-dialog
      v-model="showDialog"
      title="温馨提示"
      showConfirmButton
      show-cancel-button
      @confirm="dialogConfirm"
    >
      <p class="dialog-text">请先下载APP查看更多。</p>
    </van-dialog>
  </div>
</template>

<script>
// import shareFunc from "libs/hcShareRelatedFunc.js";
import Videojs from "video.js";
import wxSdk from "@/http/wxApi.js";
import { queryLivingRoomDetails, queryLivingByOperation } from "@/http/api";
import videojs from "video.js";

export default {
  name: "liveStreaming",
  data() {
    return {
      interactStyle: {
        height: "100px"
      },
      roomId: 10,
      videoContainer: null,
      tabContainer: null,
      livingRoomDetail: {},
      recordList: [{}, {}, {}, {}, {}],
      interactList: [],
      currentActive: 0,
      tabStyle: {
        transform: "translateX(calc(25vw - 10px))"
      },
      tabList: ["互动", "简介"],
      showDialog: false
    };
  },
  mounted() {
    const videoContainerHeight = this.$refs.videoContainer.offsetHeight;
    const tabContainerHeight = this.$refs.tabContainer.offsetHeight;
    this.interactStyle.height = `${window.innerHeight -
      videoContainerHeight -
      tabContainerHeight}px`;
    console.log(this.$route.query.roomId);
    this.roomId = this.$route.query.roomId;
    this.getLivingRoomDetail();
    this.queryLivingByOperation();
    // 每30s循环调用获取评论列表
    // this.timer = setInterval(() => {
    //   this.queryLivingByOperation();
    // }, 30000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    // 获取直播间详情
    async getLivingRoomDetail() {
      const result = await queryLivingRoomDetails({
        id: this.roomId
      });
      console.log(result);
      if (result.code === 1) {
        this.livingRoomDetail = result.data;

        if (this.livingRoomDetail.playStatus == 2) {
          this.initVideo(this.livingRoomDetail.playBackUrl);
        } else {
          this.initVideo(this.livingRoomDetail.liveStream);
        }
        document.title = this.livingRoomDetail.name;
        this.wxSign();
      }
    },

    initVideo(nowPlayVideoUrl) {
      // 这些options属性也可直接设置在video标签上，见 muted
      let options = {
        autoplay: true, // 设置自动播放
        controls: true, // 显示播放的控件
        sources: [
          // 注意，如果是以option方式设置的src,是不能实现 换台的 (即使监听了nowPlayVideoUrl也没实现)
          {
            src: nowPlayVideoUrl,
            type: "application/x-mpegURL" // 告诉videojs,这是一个hls流
          }
        ]
      };
      // videojs的第一个参数表示的是，文档中video的id
      const myPlyer = Videojs("videoRef", options, function onPlayerReady() {
        console.log("onPlayerReady 中的this指的是：", this); // 这里的this是指Player,是由Videojs创建出来的实例
        console.log(myPlyer === this); // 这里返回的是true
      });
    },
    // 获取直播间互动列表
    async queryLivingByOperation() {
      const result = await queryLivingByOperation({
        roomId: this.roomId, // 直播间id
        roomType: 2 // 直播间类型，固定值为2
      });
      if (result.code === 1) {
        this.interactList = [...this.interactList, ...result.data];
      }
    },
    // 点击关注
    handleClickFocus() {
      this.showDialog = true;
    },
    // 确认跳转App
    dialogConfirm() {
      shareFunc.downLoadApp();
    },
    handleClickTabItem(index) {
      if (this.currentActive === index) {
        return;
      }
      setTimeout(() => {
        this.currentActive = index;
      }, 350);
      this.tabStyle.transform = `translateX(calc(${index} * 50vw + 25vw - 10px))`;
    },
    wxSign() {
      wxSdk.getJSSDK({
        title: this.livingRoomDetail.sharePictureUrl,
        desc: this.livingRoomDetail.intro,
        linkurl: `https://hcfm.gztv.com/hcfmshare/#/LivingStreaming?roomId=${this.roomId}`,
        img: this.livingRoomDetail.sharePictureUrl
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.input_video {
  width: 100%;
  height: 100%;
  margin: auto;
}
.video-container {
  width: 100%;
  height: 35vh;
}

.video {
  width: 100%;
  height: 100%;
}

.tab-container {
  position: relative;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tab-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 40px;
  background: #f5f5f5;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  color: #666;
}

.tab-active {
  color: #e73828;
}

.tab-solid {
  position: absolute;
  bottom: 0;
  width: 20px;
  height: 4px;
  background: #e73828;
  border-radius: 4px;
  transition: all 0.3s linear;
}

.interact-container {
  position: absolute;
  overflow: hidden;
  overflow-y: scroll;
  width: 100%;
  background: linear-gradient(to top, #fff, #f9f9f9);
}

.user {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;
}

.tourist {
  margin-bottom: 10px;
  font-size: 14px;
}

.interact {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 15px 0 15px;

  &-item {
    width: 100%;

    &-img {
      width: 35px;
      min-width: 35px;
      height: 35px;
      border-radius: 50%;
      overflow: hidden;
    }

    &-desc {
      margin-left: 10px;
      flex: 1;

      &-nickname {
        color: #e73828;
        margin-right: 5px;
      }
    }
  }
}
.introduce-title {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #272829;
  box-sizing: border-box;
  padding: 0 13px;
}

.title-desc {
  width: 75%;
}

.play-count {
  display: flex;
  align-items: center;

  &-desc {
    color: #999;
    font-size: 14px;
    margin-left: 3px;
  }
}

.play-count img {
  width: 16px;
  height: 16px;
}

.record {
  width: 100%;
  box-sizing: border-box;
  padding: 0 13px;
  font-size: 16px;
  margin-top: 15px;
  margin-bottom: 25px;

  &-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 85px;
    height: 26px;
    background: #d4d5d6;
    border-radius: 13px;
    font-size: 14px;
  }
}

.record-item {
  margin-top: 18px;
  display: flex;
  align-items: center;
}

.item-left {
  position: relative;
  width: 128px;
  height: 74px;
  border-radius: 5px;
  overflow: hidden;
  margin-right: 13px;
}

.item-left img {
  width: 100%;
  height: 100%;
}

.item-duration {
  position: absolute;
  bottom: 6px;
  right: 14px;
  color: #f6faff;
  font-size: 10px;
}

.item-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-top: 4px;
  height: 74px;
  justify-content: space-between;

  &-top {
    font-size: 14px;
    color: #2b2c2d;
    line-height: 20px;
  }

  &-bottom {
    display: flex;
    align-items: center;

    & img {
      width: 16px;
      height: 16px;
    }
  }

  &-count {
    color: #999;
    font-size: 14px;
    margin-left: 3px;
  }
}

.anchor {
  width: 100%;
  box-sizing: border-box;
  padding: 0 13px;
  margin-top: 15px;

  &-desc {
    display: flex;
    align-items: center;
    width: 100%;

    & img {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 10px;
    }
  }

  &-nickname {
    font-size: 16px;
    color: #111;
  }
}

.anchor-bottom {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 18px;
}

.focus-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 30px;
  font-size: 13px;
  background: #e73828;
  color: #fff;
  border-radius: 15px;
}

.dialog-text {
  text-align: center;
  margin: 15px 0;
  font-size: 16px;
}

.video-class {
  width: 100%;
  height: 100%;
}
</style>
